<template>
  <div class="page">
    <div class="nav-wrapper">
      <Navbar />
    </div>
    <div class="page-wrapper">
      <div class="filter-wrapper">
        <div class="estimation-phrase">
          <p>{{ $t('display_number_estimations') }} {{ totalEstimations }}</p>
        </div>
        <div class="filter-container filter-container--auto">
          <SearchInput @update-search-value="filterEstimations" />
          <Sort :options="sortOptions" @action="filterEstimations" />
          <button
            type="button"
            class="button button--filter"
            :class="{ 'filter--active': !isList }"
            @click="setList(false)"
          >
            <i class="fas fa-th-large"></i>
          </button>
          <button
            type="button"
            class="button button--filter"
            :class="{ 'filter--active': isList }"
            @click="setList(true)"
          >
            <i class="fas fa-bars"></i>
          </button>
        </div>
      </div>

      <div class="list-container" v-if="isList">
        <List :headers="headers">
          <tr v-for="(item, i) in estimations" :key="i" class="list__line">
            <td>{{ item.client.firstName }} {{ item.client.lastName }}</td>
            <td>{{ prettyFullDate(item.createdAt) }}</td>
            <td>{{ toCurrency(item.estimationValue) }}</td>
            <td>{{ prettyFullDate(item.estimatedAt) }}</td>
          </tr>
        </List>
      </div>

      <div class="card-container" v-if="!isList">
        <EstimationCard
          v-for="(estimation, i) in estimations"
          :key="i"
          :card="estimation"
          status="sent"
          @fullView="fullView"
        />
      </div>

      <InfiniteScroll
        v-if="estimations.length < totalEstimations"
        :items-per-page="30"
        @paginate="paginateEstimations"
      />
    </div>
  </div>
</template>

<script>
import { SearchInput, Sort, InfiniteScroll } from '../../components/filters';
import Navbar from '../../components/Navbar';
import EstimationCard from '../../components/EstimationCard';
import List from '../../components/List';
import { formatDate, formatNumber, EstimationComponent } from '../../mixins';
import { infiniteLoading } from '../../lib/customEvents';

export default {
  components: {
    Navbar,
    EstimationCard,
    List,
    SearchInput,
    Sort,
    InfiniteScroll,
  },

  mixins: [formatDate, formatNumber, EstimationComponent],

  data() {
    return {
      isList: true,
      headers: ['fullname', 'reception-date', 'estimation', 'estimation.date'],
      sortOptions: [
        {
          title: 'filter.sort.newer',
          sortedElement: 'order[createdAt]',
          order: 'desc',
        },
        {
          title: 'filter.sort.older',
          sortedElement: 'order[createdAt]',
          order: 'asc',
        },
        {
          title: 'filter.sort.bigger_amount',
          sortedElement: 'order[estimationValue]',
          order: 'desc',
        },
        {
          title: 'filter.sort.lesser_amount',
          sortedElement: 'order[estimationValue]',
          order: 'asc',
        },
      ],
    };
  },

  async created() {
    const outdatedEstimations = await this.fetchEstimations({
      status: 'outdated',
      itemsPerPage: 30,
    });

    if (!outdatedEstimations || !outdatedEstimations['hydra:member']) return;

    this.estimations = outdatedEstimations['hydra:member'];

    if (!outdatedEstimations['hydra:totalItems']) return;

    this.totalEstimations = outdatedEstimations['hydra:totalItems'];
  },

  methods: {
    setList(value) {
      this.isList = value;

      if (this.isList) {
        this.$nextTick(() => document.dispatchEvent(infiniteLoading));
      }
    },
  },
};
</script>
